(() => {
  const initCartPopup = () => {
    const popup = document.getElementById('ella-exit-popup');

    if (!popup) return;

    const copyButton = document.getElementById('ella-copy-code');
    const codeElement = document.getElementById('ella-popup-code');

    /*
     * 60000 = دقيقة واحدة
     * 120000 = دقيقتان
     */
    const cartPopupCooldown = 60000;

    let lastCartPopupTime = 0;
    let popupReady = false;

    const isExcludedPage =
      window.location.pathname.includes('/checkout') ||
      window.location.pathname.includes('/account');

    if (isExcludedPage) return;

    const isPopupOpen = () => {
      return popup.classList.contains('is-open');
    };

    const openPopup = () => {
      if (!popupReady || isPopupOpen()) return;

      const currentTime = Date.now();

      if (
        lastCartPopupTime &&
        currentTime - lastCartPopupTime < cartPopupCooldown
      ) {
        return;
      }

      lastCartPopupTime = currentTime;

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ella-popup-open');
    };

    const closePopup = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ella-popup-open');
    };

    /*
     * تفعيل الكود بعد 4 ثوانٍ من فتح الصفحة.
     */
    window.setTimeout(() => {
      popupReady = true;
    }, 4000);

    /*
     * مراقبة الضغط على زر إغلاق الكارت فقط.
     */
    document.addEventListener('click', (event) => {
      const cartCloseButton = event.target.closest(
        '.halo-sidebar-close'
      );

      if (cartCloseButton) {
        window.setTimeout(() => {
          openPopup();
        }, 450);

        return;
      }

      if (event.target.closest('[data-popup-close]')) {
        closePopup();
      }
    });

    /*
     * إغلاق Popup بزر Escape.
     */
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isPopupOpen()) {
        closePopup();
      }
    });

    /*
     * نسخ كود الخصم.
     */
    if (copyButton && codeElement) {
      copyButton.addEventListener('click', async () => {
        const discountCode =
          codeElement.textContent.trim();

        try {
          await navigator.clipboard.writeText(
            discountCode
          );
        } catch (error) {
          const temporaryInput =
            document.createElement('input');

          temporaryInput.value = discountCode;
          document.body.appendChild(temporaryInput);
          temporaryInput.select();
          document.execCommand('copy');
          temporaryInput.remove();
        }

        copyButton.textContent = 'Copied!';

        window.setTimeout(() => {
          copyButton.textContent = 'Copy Code';
        }, 1500);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCartPopup,
      { once: true }
    );
  } else {
    initCartPopup();
  }
})();